import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, ParamMap, Router, RouterOutlet } from '@angular/router';
import { LoaderService } from './loader/loader.service';
import { JwtService } from './services/jwt.service';
import { UnauthorizedComponent } from './Unauthorized/unauthorized/unauthorized.component';
import { HeaderComponent } from './components/header/header.component';

import { LoaderComponent } from './loader/loader.component';
import { AuthService } from './services/auth.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: true,
    styleUrls: ['./app.component.scss'],
    imports: [
    LoaderComponent,
    RouterOutlet,
    UnauthorizedComponent,
    HeaderComponent
],
})
export class AppComponent implements OnInit {
  private _router = inject(Router);
  private readonly _currentRoute = inject(ActivatedRoute);
  private readonly _jsonWebTokenService = inject(JwtService);
  private authService = inject(AuthService);
  constructor() {
    // SM-3429: Clear any stale `mode` left in localStorage from a prior
    // Supplier/ExoForm-Designer edit session before any consumer (e.g.
    // ApiServiceService) reads it to build the Supplier/Buyer endpoint.
    // A Buyer JWT carries an empty `mode`, which storeLocally() skips, so
    // without this a stale 'supplierEdit' would route Buyer calls to
    // /API/Supplier/... and the gateway returns 403 (blank Form Preview).
    localStorage.removeItem('mode');
    this.loaderService.showLoader();
  }

  title = 'app';
  token: string = '';
  public loaderService = inject(LoaderService);

  ngOnInit(): void {
    // SM-3454: No debounceTime here. `queryParamMap` emits synchronously on
    // subscribe (it is backed by the router's current params), so storeLocally()
    // writes `mode` before child components/services are constructed. A delay
    // here let ApiServiceService construct with an empty `mode` and route
    // Supplier calls to the Buyer endpoint (403).
    this._currentRoute.queryParamMap.subscribe({
      next: (params: ParamMap) => {
        this.onQueryParamMapSubscribe(params);
        this.loaderService.hideLoader();
      },
      error: (err: { status: any }) => {
        if (err.status == 403) {
          this._router.navigate(['Unauthorized']);
        }
        this.loaderService.hideLoader();
      },
    });
  }

  onQueryParamMapSubscribe(params: ParamMap) {
    // First try to get token from query params, then fallback to localStorage
    // (localStorage may have been populated by AuthService before URL was cleared)
    let token = params.get('token') ?? '';
    if (!token) {
      token = localStorage.getItem('jsonWebToken') ?? '';
    }
    
    this._jsonWebTokenService.jsonWebToken = token;

    if (this._jsonWebTokenService.jsonWebToken) {
      this.token = this._jsonWebTokenService.jsonWebToken;
      localStorage.setItem(
        'jsonWebToken',
        this._jsonWebTokenService.jsonWebToken
      );
    }

    if (
      !this._jsonWebTokenService.jsonWebToken ||
      this._jsonWebTokenService.jsonWebToken === ''
    ) {
      this._router.navigate(['unauthorized']);
    } else {
      this.storeLocally(this._jsonWebTokenService.decodedJsonWebToken);
    }
  }

  storeLocally(token: { [key: string]: string }) {
    console.log('token',token);
    if (token) {
      const mappings = {
        pSectionId: 'SectionId',
        pTemplateId: 'TemplateId',
        pSurveyId: 'SurveyId',
        pUserId: 'UserId',
        pTitle: 'Title',
        pIsEdit: 'IsEdit',
        pformid: 'FormId',
        pIsPreview: 'PreviewMode',
        mode: 'mode',
        pFormLayout: 'FormLayout',
        pFormType: 'FormType',
        pOrgFormId: 'OrgFormId',
        pRedirectURL: 'SubmitFormRedirectURL',
        pIsParentShared: 'IsParentShared',
      };

      for (let [key, value] of Object.entries(mappings)) {
        if (token[key]) {
          if (key === 'pFormLayout') {
            localStorage.setItem(
              'isSection',
              String(token[key].toLowerCase() === 'multiple')
            );
          }
          localStorage.setItem(value, token[key]);
        } else if (key === 'mode') {
          // SM-3429: An empty/absent `mode` (Buyer tokens) must clear any
          // residual value so the Buyer endpoint is selected, rather than
          // leaving a stale 'supplierEdit' in place.
          localStorage.removeItem('mode');
        }
      }
    }
  }

  ngOnDestroy() {
    localStorage.clear();
  }
}